// Component to render configuration as YAML-like format
export function ConfigPreview({ config }: { config: any }) {
  const renderValue = (value: any, depth: number = 0): React.ReactNode => {
    const indent = "  ".repeat(depth); // 2 spaces per level

    if (value === null || value === undefined) {
      return <span className="text-muted-foreground">null</span>;
    }

    if (typeof value === "boolean") {
      return (
        <span className={value ? "text-green-600" : "text-red-600"}>
          {String(value)}
        </span>
      );
    }

    if (typeof value === "number" || typeof value === "string") {
      return <span className="text-blue-600">{String(value)}</span>;
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return <span className="text-muted-foreground">[]</span>;
      }
      return (
        <div>
          {value.map((item, index) => (
            <div key={index} className="block">
              <span className="text-muted-foreground">{indent}- </span>
              <span>{renderValue(item, depth)}</span>
            </div>
          ))}
        </div>
      );
    }

    if (typeof value === "object") {
      const entries = Object.entries(value);
      if (entries.length === 0) {
        return <span className="text-muted-foreground">{"{}"}</span>;
      }
      return (
        <div>
          {entries.map(([key, val]) => (
            <div key={key} className="block">
              <span style={{ paddingLeft: `${depth * 16}px` }}>
                <span className="font-medium text-foreground">{key}:</span>{" "}
                {typeof val === "object" &&
                val !== null &&
                (Array.isArray(val)
                  ? val.length > 0
                  : Object.keys(val).length > 0) ? (
                  <div className="block">{renderValue(val, depth + 1)}</div>
                ) : (
                  renderValue(val, depth + 1)
                )}
              </span>
            </div>
          ))}
        </div>
      );
    }

    return <span>{String(value)}</span>;
  };

  if (!config) {
    return (
      <div className="text-muted-foreground text-sm">
        No configuration selected
      </div>
    );
  }

  return <div className="text-sm font-mono">{renderValue(config)}</div>;
}
